import * as React from "react";
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#969696", d: "m7.36 8 2.97 2.97-.84.85L5.67 8l3.82-3.82.84.85z" }));
export default SvgArrowLeft;
